import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, renderSlot as _renderSlot, createBlock as _createBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-35b568b2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "NewTable__table" }
const _hoisted_2 = {
  key: 0,
  class: "thead__th"
}
const _hoisted_3 = {
  key: 1,
  class: "thead__th"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "thead__th" }, null, -1))
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { class: "NewTable__tbody" }
const _hoisted_8 = {
  key: 0,
  class: "NewTableRow bg-gray-100"
}
const _hoisted_9 = {
  key: 0,
  class: "NewTableRow__td"
}
const _hoisted_10 = {
  key: 1,
  class: "NewTableRow__td"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "NewTableRow__td" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_new_checkbox = _resolveComponent("new-checkbox")!
  const _component_new_table_row = _resolveComponent("new-table-row")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["NewTable", { centered: _ctx.isCentered }])
  }, [
    _createElementVNode("table", _hoisted_1, [
      _createElementVNode("thead", {
        class: _normalizeClass(["NewTable__thead", { 'whitespace-nowrap': _ctx.nowrap }])
      }, [
        _createElementVNode("tr", {
          class: _normalizeClass(['thead__tr', { 'thead__tr-regular': _ctx.regularTable }])
        }, [
          (_ctx.hasCheckboxColumn)
            ? (_openBlock(), _createElementBlock("th", _hoisted_2, [
                _createVNode(_component_new_checkbox, {
                  class: "checkbox--table",
                  value: false,
                  onChange: _ctx.onSelectAll
                }, null, 8, ["onChange"])
              ]))
            : _createCommentVNode("", true),
          (_ctx.hasIndexColumn)
            ? (_openBlock(), _createElementBlock("th", _hoisted_3, "№"))
            : _createCommentVNode("", true),
          _hoisted_4,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columns, (column, i) => {
            return (_openBlock(), _createElementBlock("th", {
              key: `TableRow-${i}`,
              class: "thead__th"
            }, [
              (_ctx.isOneWord)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(column.name.split(' '), (name, k) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: `column-name-${k}`
                      }, _toDisplayString(name), 1))
                    }), 128))
                  ]))
                : (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(column.name), 1))
            ]))
          }), 128))
        ], 2)
      ], 2),
      _createElementVNode("tbody", _hoisted_7, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rows, (row, i) => {
          return (_openBlock(), _createBlock(_component_new_table_row, {
            key: `TableRow-${i}`,
            columns: _ctx.columns,
            row: row,
            index: i,
            "table-index": i,
            "has-checkbox-column": _ctx.hasCheckboxColumn,
            "has-index-column": _ctx.hasIndexColumn,
            checked: _ctx.isRowSelected(row),
            onClick: ($event: any) => (_ctx.onRowClick(row)),
            class: _normalizeClass({
                        clickable: _ctx.clickableRow,
                        danger: row.isRed,
                        bold: _ctx.isBold,
                    }),
            "regular-table": _ctx.regularTable,
            "is-centered": _ctx.isCentered
          }, {
            checkbox: _withCtx(() => [
              (_ctx.$slots.checkbox)
                ? _renderSlot(_ctx.$slots, "checkbox", {
                    key: 0,
                    row: row,
                    disabled: _ctx.isCheckboxDisabled,
                    checked: _ctx.isRowSelected(row)
                  }, undefined, true)
                : (_openBlock(), _createBlock(_component_new_checkbox, {
                    key: 1,
                    class: "checkbox--blue",
                    value: _ctx.isRowSelected(row),
                    disabled: _ctx.isCheckboxDisabled,
                    onChange: ($event: any) => (_ctx.onSelectRow(row))
                  }, null, 8, ["value", "disabled", "onChange"]))
            ]),
            "table-index": _withCtx(({ tableIndex }) => [
              (_ctx.$slots['table-index'])
                ? _renderSlot(_ctx.$slots, "table-index", {
                    key: 0,
                    tableIndex: tableIndex
                  }, undefined, true)
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createTextVNode(_toDisplayString(i + 1), 1)
                  ], 64))
            ]),
            td: _withCtx(({ row, column, colindex, rowindex }) => [
              (_ctx.$slots.td)
                ? _renderSlot(_ctx.$slots, "td", {
                    key: 0,
                    row: row,
                    colindex: colindex,
                    rowindex: rowindex,
                    column: column
                  }, undefined, true)
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createTextVNode(_toDisplayString(row[column.key]), 1)
                  ], 64))
            ]),
            actions: _withCtx(({ row, rowindex }) => [
              (_ctx.$slots['row-actions'])
                ? _renderSlot(_ctx.$slots, "row-actions", {
                    key: 0,
                    row: row,
                    rowindex: rowindex
                  }, undefined, true)
                : _createCommentVNode("", true)
            ]),
            _: 2
          }, 1032, ["columns", "row", "index", "table-index", "has-checkbox-column", "has-index-column", "checked", "onClick", "class", "regular-table", "is-centered"]))
        }), 128)),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.nestedRows, (nestedrow, i) => {
          return (_openBlock(), _createElementBlock(_Fragment, {
            key: `TableNestedRow-${i}`
          }, [
            _createVNode(_component_new_table_row, {
              columns: _ctx.columns,
              row: nestedrow,
              index: i,
              "table-index": i + _ctx.rows.length,
              "has-checkbox-column": _ctx.hasCheckboxColumn,
              "has-index-column": _ctx.hasIndexColumn,
              class: _normalizeClass({
                            'NewTableRow--expander': _ctx.isNestedRowExpanded(nestedrow),
                            bold: _ctx.isBold,
                        }),
              checked: _ctx.isNestedSelected(nestedrow),
              "regular-table": _ctx.regularTable,
              "is-centered": _ctx.isCentered
            }, {
              checkbox: _withCtx(() => [
                (_ctx.$slots['nested-checkbox'])
                  ? _renderSlot(_ctx.$slots, "nested-checkbox", { key: 0 }, undefined, true)
                  : (_openBlock(), _createBlock(_component_new_checkbox, {
                      key: 1,
                      class: "checkbox--blue",
                      value: _ctx.isNestedSelected(nestedrow),
                      onChange: ($event: any) => (_ctx.onSelectNested(nestedrow))
                    }, null, 8, ["value", "onChange"]))
              ]),
              "table-index": _withCtx(({ tableIndex }) => [
                (_ctx.$slots['nested-table-index'])
                  ? _renderSlot(_ctx.$slots, "nested-table-index", {
                      key: 0,
                      tableIndex: tableIndex
                    }, undefined, true)
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createTextVNode(_toDisplayString(tableIndex + 1), 1)
                    ], 64))
              ]),
              td: _withCtx(({ row, column, colindex, rowindex }) => [
                (_ctx.$slots['nested-td'])
                  ? _renderSlot(_ctx.$slots, "nested-td", {
                      key: 0,
                      row: row,
                      colindex: colindex,
                      rowindex: rowindex,
                      column: column
                    }, undefined, true)
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createTextVNode(_toDisplayString(nestedrow[column.key]), 1)
                    ], 64))
              ]),
              actions: _withCtx(({ row, rowindex }) => [
                (_ctx.$slots['nested-actions'])
                  ? _renderSlot(_ctx.$slots, "nested-actions", {
                      key: 0,
                      row: row,
                      rowindex: rowindex
                    }, undefined, true)
                  : _createCommentVNode("", true)
              ]),
              _: 2
            }, 1032, ["columns", "row", "index", "table-index", "has-checkbox-column", "has-index-column", "class", "checked", "regular-table", "is-centered"]),
            (_ctx.nestedRowsExpandKey && nestedrow[_ctx.nestedRowsExpandKey])
              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(nestedrow[_ctx.nestedRowsExpandKey], (nestedrow_data, j) => {
                  return (_openBlock(), _createBlock(_component_new_table_row, {
                    class: _normalizeClass(["NewTableRow--expanded", {
                                hidden: !_ctx.isNestedRowExpanded(nestedrow),
                                last: j === nestedrow[_ctx.nestedRowsExpandKey].length - 1,
                                clickable: _ctx.clickableNested,
                                danger: nestedrow_data.isRed,
                                bold: _ctx.isBold,
                            }]),
                    key: `NestedRowData-${j}`,
                    columns: _ctx.columns,
                    row: nestedrow_data,
                    index: j,
                    "parent-index": i,
                    "has-checkbox-column": _ctx.hasCheckboxColumn,
                    "has-index-column": _ctx.hasIndexColumn,
                    checked: _ctx.isNestedSelected(nestedrow),
                    onClick: ($event: any) => (_ctx.onNestedRowClick(nestedrow_data)),
                    "regular-table": _ctx.regularTable,
                    "is-centered": _ctx.isCentered
                  }, {
                    checkbox: _withCtx(() => [
                      (_ctx.$slots['nested-row-checkbox'])
                        ? _renderSlot(_ctx.$slots, "nested-row-checkbox", { key: 0 }, undefined, true)
                        : (_openBlock(), _createBlock(_component_new_checkbox, {
                            key: 1,
                            class: "checkbox--blue",
                            value: _ctx.isRowSelected(nestedrow_data),
                            onChange: ($event: any) => (_ctx.onSelectRow(nestedrow_data))
                          }, null, 8, ["value", "onChange"]))
                    ]),
                    "table-index": _withCtx(({ tableIndex }) => [
                      (_ctx.$slots['nested-row-table-index'])
                        ? _renderSlot(_ctx.$slots, "nested-row-table-index", {
                            key: 0,
                            tableIndex: tableIndex
                          }, undefined, true)
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _createTextVNode(_toDisplayString(tableIndex + 1), 1)
                          ], 64))
                    ]),
                    td: _withCtx(({ row, parentindex, colindex, rowindex, column }) => [
                      (_ctx.$slots['nested-row-td'])
                        ? _renderSlot(_ctx.$slots, "nested-row-td", {
                            key: 0,
                            parentrow: nestedrow,
                            row: row,
                            parentindex: parentindex,
                            colindex: colindex,
                            rowindex: rowindex,
                            column: column
                          }, undefined, true)
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _createTextVNode(_toDisplayString(nestedrow_data[column.key]), 1)
                          ], 64))
                    ]),
                    actions: _withCtx(({ row, rowindex }) => [
                      (_ctx.$slots['nested-row-actions'])
                        ? _renderSlot(_ctx.$slots, "nested-row-actions", {
                            key: 0,
                            row: row,
                            rowindex: rowindex,
                            parentrow: nestedrow
                          }, undefined, true)
                        : _createCommentVNode("", true)
                    ]),
                    _: 2
                  }, 1032, ["columns", "row", "index", "parent-index", "has-checkbox-column", "has-index-column", "class", "checked", "onClick", "regular-table", "is-centered"]))
                }), 128))
              : _createCommentVNode("", true)
          ], 64))
        }), 128)),
        (_ctx.summaryRow)
          ? (_openBlock(), _createElementBlock("tr", _hoisted_8, [
              (_ctx.hasCheckboxColumn)
                ? (_openBlock(), _createElementBlock("td", _hoisted_9))
                : _createCommentVNode("", true),
              (_ctx.hasIndexColumn)
                ? (_openBlock(), _createElementBlock("td", _hoisted_10))
                : _createCommentVNode("", true),
              _hoisted_11,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columns, (column, j) => {
                return (_openBlock(), _createElementBlock("td", {
                  key: `NewTableRow-${j}`,
                  class: "NewTableRow__td"
                }, [
                  _renderSlot(_ctx.$slots, `summary-${column.key}`, { column: column }, undefined, true)
                ]))
              }), 128))
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ], 2))
}